import { watch, type Ref } from 'vue'

// Naive UI's NDrawer traps focus while open but returns focus to
// document.body when it closes. Keyboard-only users then have to tab
// from the start of the document to get back to the trigger button —
// a routine drawer dismissal becomes a navigation reset.
//
// Pass a ref controlling drawer visibility; this captures whatever was
// focused when the drawer opens and restores focus to that element when
// it closes. Wraps `requestAnimationFrame` so the restore happens after
// Naive UI's own focus cleanup, otherwise the trap snatches focus back.
export function useRestoreFocusOnClose(open: Ref<boolean>): void {
  let trigger: HTMLElement | null = null

  watch(open, (next, prev) => {
    if (next && !prev) {
      const active = document.activeElement
      trigger = active instanceof HTMLElement ? active : null
      return
    }
    if (!next && prev && trigger) {
      const target = trigger
      trigger = null
      requestAnimationFrame(() => {
        if (typeof target.focus === 'function') target.focus()
      })
    }
  })
}
